const INIT_STATE = [
   {
      widgetId: null,
      widgetType: "",
      settings: {}
   }
];

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_WIDGET_CACHE": {
         return [...action.payload];
      }
      default:
         return state;
   }
};
